import { Component, Input } from '@angular/core';
import { Flight } from '../../menu.model'

@Component({
  selector: 'flights',
  templateUrl: './flights.component.html',
  styleUrls: ['./flights.component.scss']
})
export class FlightsComponent {

  @Input() flightList: Array<Flight> = [];
  @Input() verticalFlights: Array<Flight> = [];
  @Input() activeSection: string | undefined;

  constructor() {}

}
